































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Portfolio } from '@/Portfolio'
import { SimpleSet } from '@/SimpleSet'
import { MomentOwned, sortOrderTypes } from '@/MomentOwned'
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import MomentOwnedListComponent from '@/components/MomentOwnedListComponent.vue';                               // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'
import { Challenge } from '@/Challenge'
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { TokenUser } from '@/TokenUser'
import { Auction } from '@/Auction'
import { Account } from '@/Account'
import { AdvancedSearch } from '@/Moment'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'PortfolioComponent',
  components: { MomentOwnedListComponent, MomentSelectorAndSorterComponent, ModalWrapperComponent }
})
export default class PortfolioComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: false })
  public isSignedInUser: boolean

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public flowAddress: string = null;
  public moments: MomentOwned[] = []
  public portfolio: Portfolio = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null
  public fmv: number = null
  public costBasis: number = null
  public advancedSearchStringUsed: string = null

  public auctions: Auction[] = null

  // UI and filter options
  public sortOrder: sortOrderTypes = this.getSortOrders()[0].sort
  public playerID: number = null
  public setID: number = null
  public playID: number = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // used to be dapper mode or you had to be the signed in user looking at own Portfolio
  // public showCS(): boolean { return (utils_topshot.getDapperMode()) || (this.isSignedInUser && this.moments && this.moments.length > 1 && this.moments[1].collectorScore != null) }
  
  // changed to make it as long as you're signed in, you can see anybody's (so that you can help a friend)
  public showCS(): boolean { return (/*this.user && */this.moments && this.moments.length > 1 && this.moments[1].collectorScore2b != null) }

  // events from MomentSelectorAndSorterComponent
  public async onChangedSort(sortOrder: { label: string, sort: sortOrderTypes }) {
    this.sortOrder = sortOrder.sort
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }
  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID
    this.playID = duo.playID
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async onChangedAdvanced(advancedSearch: AdvancedSearch) {
    if (advancedSearch) this.advancedSearchStringUsed = JSON.stringify(advancedSearch)
    else this.advancedSearchStringUsed = null

    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }  

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public getSortOrders(): Array<{ label: string, sort: sortOrderTypes }> {
    return [
        { label: 'Sort by Acquired (recent)', sort: 'AcquiredDate_DESC' },
        { label: 'Sort by Acquired (oldest)', sort: 'AcquiredDate_ASC' },
        { label: 'Sort by FMV (highest)', sort: 'FMV_DESC' },
        { label: 'Sort by FMV (lowest)', sort: 'FMV_ASC' },
        { label: 'Sort by Paid (highest)', sort: 'AcquiredPrice_DESC' },
        { label: 'Sort by Paid (lowest)', sort: 'AcquiredPrice_ASC' },
        { label: 'Sort by Unrealized Gain', sort: 'Gain_DESC' },
        { label: 'Sort by Unrealized Loss', sort: 'Gain_ASC' },
        { label: 'Sort by 24h Gains', sort: 'Movement_DESC' },
        { label: 'Sort by 24h Losses', sort: 'Movement_ASC' },
        { label: 'Sort by TSS (highest)', sort: 'CS_DESC' },
        { label: 'Sort by TSS (lowest)', sort: 'CS_ASC' },
        { label: 'Sort by Serial (lowest)', sort: 'Serial_ASC' },
        { label: 'Sort by Serial (highest)', sort: 'Serial_DESC' },
        { label: 'Sort by Player Name', sort: 'Player_ASC' },
        { label: 'Sort by Team', sort: 'Team_ASC' },

    ]
  }

  public async setFlowAddress(flowAddress: string, forceRefetch: boolean) {
    if (forceRefetch || !this.portfolio || flowAddress !== this.flowAddress) {
      this.flowAddress = flowAddress
      this.pageNumberToLoadNext = 1
      this.portfolio = null
      this.numMoments = 0
      this.moments = []
      this.paginationResult = null
      await this.fetchData(false, this.pageNumberToLoadNext)
    }
  }

  public getNiceGainString(): string {
    return utils_topshot.getNiceGainString(this.fmv - this.costBasis)
  }
  public getGainClass(): string {
    return utils_topshot.getGainClass(this.fmv - this.costBasis)
  }

  public onClickedCreateAuction(moment: MomentOwned) {
    const dynamicProps: any = {
      moment,
      portfolio: this.portfolio,
      account: new Account(this.portfolio.account),
      auctions: this.auctions
    };
    (this.$refs.AuctionPostFormComponent as ModalWrapperComponent).show('Post Auction for Sale', 'md', dynamicProps)
  }

  public onClickedViewAuction(moment: MomentOwned) {
    const dynamicProps: any = { auctionId: moment.auction.getIdAsString(), temporaryURL: moment.auction.getLiveTokenAuctionLink() };
    (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
  }

  public async onAuctionPostFormClosed(componentName: string, showing: boolean, payload: any) {
    if (showing) return
    if (payload) {
      // existence of payload means the user edited, deleted or created auction, so let's be lazy and refetch the full list of auctions by this user
      const auction: Auction = payload
      await this.fetchAuctions()
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);
  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  private async fetchAuctions(): Promise<number> {
    const url: string = utils.getURLprefix() + `/api/topshot/auctions/`;
    try {
      const response: any = await utils.makeGetCall(url);
      const pos: object[] = response.data.auctions
      if (pos) this.auctions = pos.map((po) => new Auction(po));
      this.auctions.sort((a1, a2) => a1.created.getTime() - a2.created.getTime())     // later ones override any earlier ones

      // fill in client-only "auction" field of MomentOwned
      if (this.moments) {
        const auctionsByMomentID: { [ momentID: string ]: Auction } = {}
        for (const auction of this.auctions) auctionsByMomentID[auction.momentID.toString()] = auction
        for (const moment of this.moments) moment.auction = auctionsByMomentID[moment.momentID.toString()]
      }

      if (this.$store.state.devmode) console.log(`fetchAuctions() returned ${this.auctions.length} auctions`)

      return this.auctions.length
    } catch (error) {
      if (this.$store.state.devmode) console.log(error);
    }

  }

  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    const header: MomentOwned = new MomentOwned(null)
    header.momentID = 0
    header.valueFMV = 0

    if (!this.flowAddress) return 0
    let url: string = utils.getURLprefix() + `/api/topshot/portfolio/`;
    url += this.flowAddress
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder}`;
    if (this.playerID) url += `&playerID=${this.playerID}`
    if (this.setID) url += `&setID=${this.setID}`
    if (this.playID) url += `&playID=${this.playID}`
    if (!utils_topshot.getChallenges()) url += `&sc=true`
    if (this.advancedSearchStringUsed) url += `&advancedSearch=${encodeURIComponent(this.advancedSearchStringUsed)}`
    url += `&useCS2bForSorting=true`

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`Portfolio.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up subtotals
      this.numMoments = response.data.numMoments
      this.fmv = response.data.fmv
      this.costBasis = response.data.costBasis

      // load up the portfolio
      this.portfolio = new Portfolio(response.data.portfolio)

      // load up the moments separately from the portfolio object in case we want to do paging (might do everything inside portfolio eventually)
      let newRawItems: MomentOwned[] = response.data.portfolio.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentOwned(po));
        if (pageNumberWhenCalled === 1) this.moments = [ header ].concat(newRawItems);
        else this.moments = this.moments.concat(newRawItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        if (this.$store.state.devmode) console.log(this.paginationResult.nextPage, this.pageNumberToLoadNext)
        if (this.$store.state.devmode) console.log(this.paginationResult.totalResults, this.moments.length)

        if (this.isSignedInUser) await this.fetchAuctions()

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }
    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      this.$store.commit("setLoading", { loading: false });
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.moments.length} moments}`)
  }
}
